import { Button, ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import React, { ChangeEvent, FormEvent, useState } from 'react';
import { Collapse } from 'react-collapse';

import { getTranslation, keys } from '../../../../../../Resources/Translations';
import { RenderHTML } from '../../../../../ReactComponents/RenderHTML';
import { UnsubscribeReasonProps } from './UnsubscribeReasonProps.csharp';

interface Option {
    name: string;
    label: string;
    value: boolean;
}

export const UnsubscribeReason = (props: UnsubscribeReasonProps) => {
    const {
        model: { unsubscribeOptions, unsubscribeReasonHeading, unsubscribeReasonBody, subscribeAgainText },
        signUpPath
    } = props;

    const [unsubscribeReason, setUnsubscribeReason] = useState<Option[]>(
        unsubscribeOptions
            ? unsubscribeOptions.map((x) => ({
                  name: x.code,
                  label: x.text,
                  value: false
              }))
            : []
    );
    const [isError, setIsError] = useState<boolean>(false);

    const handleChange = (event: ChangeEvent<HTMLInputElement>, index: number) => {
        const isChecked = event.target.checked;

        const checkboxes = [...unsubscribeReason];
        checkboxes[index] = { ...checkboxes[index], value: isChecked };

        setUnsubscribeReason(checkboxes);
        if (isError) setIsError(!checkboxes.some((x) => x.value));
    };

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        const checked = unsubscribeReason.filter((x) => x.value).map((x) => x.name);

        if (checked.length === 0) {
            setIsError(true);
            event.preventDefault();
            return;
        }

        const queryParams = checked.map((x) => 'reason=' + x).join('&');
        const queryString = `?${queryParams}`;
        const currentUrl = window.location.pathname;

        const newUrl = `${currentUrl}${queryString}`;
        window.location.replace(newUrl);
        event.preventDefault();
    };

    return (
        <div className="UnsubscribeReason">
            {unsubscribeReasonHeading && <h1 className="UnsubscribeReason__Heading">{unsubscribeReasonHeading}</h1>}

            {unsubscribeReasonBody && (
                <div className="UnsubscribeReason__Description">
                    <RenderHTML html={unsubscribeReasonBody} />
                </div>
            )}

            {unsubscribeReason && (
                <form className={classNames('UnsubscribeReason__Form', isError && 'UnsubscribeReason__Form--Error')} onSubmit={handleSubmit}>
                    {unsubscribeReason.map((item, i) => (
                        <div className="CustomCheckbox" key={item.name}>
                            <input type="checkbox" id={item.name} name={item.name} checked={item.value} onChange={(e) => handleChange(e, i)} />
                            <label htmlFor={item.name}>{item.label}</label>
                        </div>
                    ))}

                    <Collapse isOpened={isError}>
                        <span className="UnsubscribeReason__Error">{getTranslation(keys['newsletter.UnsubscribeReasonNotSelected'])}</span>
                    </Collapse>

                    <Button size={ButtonSize.Medium} type="submit" className="UnsubscribeReason__Submit">
                        {getTranslation(keys['newsletter.send'])}
                    </Button>
                </form>
            )}

            {subscribeAgainText && (
                <div className="UnsubscribeReason__SubscribeAgain">
                    {subscribeAgainText && <span>{subscribeAgainText}</span>}
                    <a href={`/${signUpPath}`}>{getTranslation(keys['newsletter.SignUpAgain'])}</a>
                </div>
            )}
        </div>
    );
};
